import { render, staticRenderFns } from "./publishEvaluate.vue?vue&type=template&id=5ad33d8e"
import script from "./publishEvaluate.vue?vue&type=script&lang=js"
export * from "./publishEvaluate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports